import {
    ANALYTICS_INITIAL_STATE,
    ANALYTICS_POPULATE,
    SELECT_LOCATIONS,
    SELECT_DATES,
    GET_TRENDING_DATA,
    GET_METRIC_LIST,
    UPDATE_TOP_ITEMS,
    UPDATE_LOWEST_ITEMS,
} from '../../constants/types';

import moment from 'moment';


export const INITIAL_STATE = {
    sales_by_shift:{
        "series": [
          {
            "name": 'Morning',
            // "yAxis": 1,
            "color": {
              "linearGradient": {
                "x2": 0,
                "y1": 0,
                "x1": 0,
                "y2": 1
              },
              "stops": [
                [
                  0,
                  "#f2a942"
                ],
                [
                  1,
                  "#ffb91a"
                ]
              ]
            },
            "type": "column",
            "data": [
              10000,
              15000,
              18000,
              15000,
              21000,
              29000,
              33000
            ],
            "showInLegend": true
          },
          {
            "name": "Evening",
            // "yAxis": 0,
            "color": {
              "linearGradient": {
                "x2": 0,
                "y1": 0,
                "x1": 0,
                "y2": 1
              },
              "stops": [
                [
                  0,
                  "#4363da"
                ],
                [
                  1,
                  "#1eb4d2"
                ]
              ]
            },
            "type": "column",
            "data": [
              12000,
              18000,
              20500,
              20000,
              27000,
              37000,
              40500
            ],
            "showInLegend": true
          },
        ],
        "categories": [
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
          "Sun"
        ]
    },
    inventory_chart:{
        "series": [
          {
            "name": "Sales",
            "yAxis": 0,
            "color": {
              "linearGradient": {
                "x2": 0,
                "y1": 0,
                "x1": 0,
                "y2": 1
              },
              "stops": [
                [
                  0,
                  "#feba1b"
                ],
                [
                  1,
                  "#f8c282"
                ]
              ]
            },
            "type": "column",
            "data": [
              163368,
              173893,
              153059,
              231385,
              251645,
              330791,
              326440
            ],
            "showInLegend": false
          }
        ],
        "categories": [
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
          "Sun"
        ]
    },
    customer_footfall:{
        "series": [
          {
            "name": "Sales",
            "yAxis": 0,
            "color": {
              "linearGradient": {
                "x2": 0,
                "y1": 0,
                "x1": 0,
                "y2": 1
              },
              "stops": [
                [
                  0,
                  "#4fb8f1"
                ],
                [
                  1,
                  "#00cace"
                ]
              ]
            },
            "type": "column",
            "data": [
              163368,
              173893,
              153059,
              231385,
              251645,
              330791,
              326440
            ],
            "showInLegend": false
          }
        ],
        "categories": [
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
          "Sun"
        ]
    },
    ticket_size_chart:{
        "series": [
          {
            "name": "Sales",
            "yAxis": 0,
            "color": {
              "linearGradient": {
                "x2": 0,
                "y1": 0,
                "x1": 0,
                "y2": 1
              },
              "stops": [
                [
                  0,
                  "#d764e7"
                ],
                [
                  1,
                  "#f7bf86"
                ]
              ]
            },
            "type": "column",
            "data": [
              163368,
              173893,
              153059,
              231385,
              251645,
              330791,
              326440
            ],
            "showInLegend": false
          }
        ],
        "categories": [
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
          "Sun"
        ]
    },
    ticket_size:{
        header:'Ticket Size',
        original_value:3500,
        value: 'Rs. 3,500',
        data:{},
        text:''
    },
    items_per_ticket:{
        header:'Items per Ticket',
        original_value:500,
        value: 'Rs. 500',
        data:{},
        text:''
    },
    customers_served:{
        header:'Customers Served',
        original_value:178,
        value: 'Rs. 178',
        data:{},
        text:''
    },
    compile_time: '',
    locations: [],
    discounts: {},
    goods_receiving: {
        data_one: {},
        data_two: {}
    },
    gross_margin: {
        data_one: {},
        data_two: {}
    },
    shell_retailer_margin:{},
    gross_sales: {},
    net_sales: {},
    service_charges: {},
    avg_sales: {},
    total_orders: {},
    avg_order_size: {},
    top_basket_category: {},
    inventory: {
        data: {
            headers: [],
            values: []
        }
    },
    overdue_invoices: {
        data_one: {},
        data_two: {}
    },
    payment_method: {
        data: {
            list: [],
        }
    },

    payment_method_chart: {
        categories: [], series: []
    },
    avg_order_value: {
        data: {
            headers: [],
            topHeaders: [],
            values: [],
        }
    },
    total_customers: {
        data: {
            headers: [],
            topHeaders: [],
            values: [],
        }
    },
    sales_by_category: {
        data: {
            headers: [],
            topHeaders: [],
            values: [],
        }
    },
    sales_by_sub_category: {
        data: {
            headers: [],
            topHeaders: [],
            values: [],
        }
    },
    top_items_by_margin: {
        data: {
            headers: [],
            topHeaders: [],
            values: [],
        }
    },
    top_items_by_sales: {
        header: null,
        data: {
            headers: [],
            topHeaders: [],
            values: [],
        }
    },
    lowest_items_by_sales: {
        data: {
            headers: [],
            topHeaders: [],
            values: [],
        }
    },
    total_cogs: {},
    voids: {},
    void_number: {},
    refunds: {},
    new_taxes: {},
    net_taxes: {},
    total_collected: {},
    filters: {
        selectedLocations: [],
        selectedDate: {
            'start_date': moment().subtract(1, 'days').format('YYYY-MM-DD'),
            'end_date': moment().subtract(1, 'days').format('YYYY-MM-DD')
        }
    },
    all_locations_insights: [],
    sales_by_store: { categories: [], series: [] },
    sales_by_day: { categories: [], series: [] },
    sales_by_hour_chart: { categories: [], series: [] },
    sales_by_category_chart: { series: [], title: {} },
    payment_methods_by_day_chart: { categories: [], series: [] },
    refund_chart: { categories: [], series: [] },
    voids_chart: { categories: [], series: [] },
    grns_chart: {
        categories: [], series: []
    },
    invoice_chart: {
        categories: [], series: []
    },
    trending_data: [],
    metric_list: []
}

export const Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ANALYTICS_POPULATE:
            return { ...state, ...action.payload };
        case SELECT_LOCATIONS:
            return { ...state, filters: { ...state.filters, selectedLocations: action.payload } };
        case SELECT_DATES:
            return { ...state, filters: { ...state.filters, selectedDate: action.payload } };
        case ANALYTICS_INITIAL_STATE:
            return INITIAL_STATE;
        case GET_TRENDING_DATA:
            return { ...state, trending_data: action.payload };
        case GET_METRIC_LIST:
            return { ...state, metric_list: action.payload };
        case UPDATE_TOP_ITEMS:
            return { ...state, top_items_by_sales: action.top_items_by_sales };
        case UPDATE_LOWEST_ITEMS:
            return { ...state, lowest_items_by_sales: action.lowest_items_by_sales }
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/modules/analytics/AnalyticsReducer.js